import type {HistoryRecord} from '../../history/data/mockHistory'
import {parseStatusDate, valueText} from './statusBoard'

export function calendarDateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function calendarDateFromKey(key: string): Date {
  const [year, month, day] = key.split('-').map(Number)
  return new Date(year, month - 1, day || 1)
}

export function calendarDateLabel(date: Date): string {
  return date.toLocaleDateString('pt-BR', {day: 'numeric', month: 'long', year: 'numeric'})
}

export function shiftCalendarMonth(month: Date, direction: number): Date {
  return new Date(month.getFullYear(), month.getMonth() + direction, 1)
}

export function buildStatusCalendar(month: Date, records: HistoryRecord[], today = new Date()) {
  const first = new Date(month.getFullYear(), month.getMonth(), 1)
  const last = new Date(month.getFullYear(), month.getMonth() + 1, 0)
  const offset = (first.getDay() + 6) % 7
  const length = Math.ceil((offset + last.getDate()) / 7) * 7
  const spans = records.map((record) => {
    const start = parseStatusDate(valueText(record.values.inicioVigencia))
    const end = parseStatusDate(valueText(record.values.fimVigencia))
    if (!start || !end || end < start) return null
    return {record, start: calendarDateKey(start), end: calendarDateKey(end)}
  }).filter((span): span is NonNullable<typeof span> => span !== null)
  const firstKey = calendarDateKey(first)
  const lastKey = calendarDateKey(last)
  return {
    monthCount: spans.filter((span) => span.start <= lastKey && span.end >= firstKey).length,
    undatedCount: records.length - spans.length,
    days: Array.from({length}, (_, index) => {
      const date = new Date(first.getFullYear(), first.getMonth(), index - offset + 1)
      const key = calendarDateKey(date)
      return {
        date, key,
        currentMonth: date.getMonth() === month.getMonth(),
        today: key === calendarDateKey(today),
        records: spans.filter((span) => span.start <= key && span.end >= key).map((span) => span.record),
      }
    }),
  }
}
